
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DBTBPAFBP",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DBTBPAFBP.vue